import {
  usePointSmartLkCreateMutation,
  SmartlkPointCreateMutationInput,
  PointPureType,
} from '@shared/api/graphql/generated';

import { FetchPolicyKeys } from '@shared/api/graphql/types';

export type PointCreateRequestResultPointType = Pick<
  PointPureType,
  'id' | 'address' | 'comment' | 'license' | 'isEnabled'
>;

export type PointCreateRequestResultType = {
  ok: boolean;
  point?: PointCreateRequestResultPointType;
};

const usePointCreate = () => {
  const [mutation, mutationResult] = usePointSmartLkCreateMutation({
    fetchPolicy: FetchPolicyKeys.NETWORK_ONLY,
  });

  const request = async (input: SmartlkPointCreateMutationInput): Promise<PointCreateRequestResultType> => {
    const mutationResult = await mutation({
      variables: { input },
      refetchQueries: ['pointList'],
    });

    return {
      ok: !!mutationResult.data?.smartlkPointCreate?.ok,
      point: mutationResult.data?.smartlkPointCreate?.point || undefined,
    };
  };

  return {
    error: mutationResult.error,
    loading: mutationResult.loading,
    called: mutationResult.called,
    request,
  };
};

export default usePointCreate;
